import Input from 'component/atom/forms/input/input/Input';
import Modal from 'component/hoc/modal/Modal';
import { useFormik } from 'formik';
import { userEndpoints } from 'hooks/endpoints';
import { usePost } from 'hooks/usePost';
import React from 'react';
import * as Yup from 'yup';
import styles from './ChangePAssword.module.scss';
import { useEffect } from 'react';
import { userToast } from 'helpers/toastMessages';
const Form = ({ formik }) => {
  return (
    <form
      autoComplete='off'
      onSubmit={formik.handleSubmit}
      className='formCont'
    >
      <Input
        label='New Password'
        placeholder='New Password'
        name='newPassword'
        value={formik.values.newPassword}
        onChange={formik.handleChange}
        error={formik.errors.newPassword}
        touched={formik.touched.newPassword}
        inputType='password'
      />
      <Input
        label='Repeat New Password'
        placeholder='Repeat New Password'
        name='repeatesNewPassword'
        value={formik.values.repeatesNewPassword}
        onChange={formik.handleChange}
        error={formik.errors.repeatesNewPassword}
        touched={formik.touched.repeatesNewPassword}
        inputType='password'
      />
    </form>
  );
};

const ChangePassword = ({ isOpen, onClose, id }) => {
  const { mutate: ChangePassword, isPending } = usePost({
    onSuccessToast: userToast.resetPassword,
    toastType: 'update',
  });

  const validationSchema = Yup.object({
    newPassword: Yup.string()
      .required('New Password is Required')
      .min(6, 'New Password must be at least 6 characters'),
    repeatesNewPassword: Yup.string()
      .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
      .required('Required'),
  });
  const formik = useFormik({
    initialValues: {
      newPassword: '',
      repeatesNewPassword: '',
    },
    validationSchema,
    onSubmit: (values) => {
      ChangePassword(
        {
          url: userEndpoints?.changePassword(id, values.newPassword),
        },
        {
          onSuccess: () => {
            onClose();
          },
        }
      );
    },
    enableReinitialize: true,
  });
  useEffect(() => {
    if (!isOpen) {
      formik.resetForm();
    }
  }, [isOpen]);
  return (
    <div>
      <Modal
        title='Change Password'
        isOpen={isOpen}
        onClose={onClose}
        modalContent={{
          component: <Form formik={formik} />,
        }}
        onSubmit={formik.handleSubmit}
        buttonType='submit'
        onSubmitstyles={{
          onSubmit: {
            label: 'Update',
            type: 'save',
            opicBAckground: true,
          },
        }}
        isLoading={isPending}
      />
    </div>
  );
};
export default ChangePassword;
